import { handleActions } from 'redux-actions'
import { SET_MALL_ORDER_CONFIRM_DATA, SET_MALL_ORDER_CONFIRM_COUPON } from '../constants/mallConstant'

let initState = {
  productList: [],

  // map
  selectedCouponMap: {},
  selectedCommonCoupon: { couponId: '', couponDesc: '不使用' }
}

export const mallOrderConfirm = handleActions({
  [SET_MALL_ORDER_CONFIRM_DATA]: (state, action) => {
    let { productList, selectedCouponMap } = action.payload
    productList = (Array.isArray(productList)) ? productList : []
    selectedCouponMap = selectedCouponMap ? selectedCouponMap : {}
    localStorage.setItem('productList', JSON.stringify(productList))
    localStorage.setItem('selectedCouponMap', JSON.stringify(selectedCouponMap))
    return { productList, selectedCouponMap, selectedCommonCoupon: initState.selectedCommonCoupon }
  },
  [SET_MALL_ORDER_CONFIRM_COUPON]: (state, action) => {
    let { selectedCouponMap, selectedCommonCoupon } = action.payload
    localStorage.setItem('selectedCouponMap', JSON.stringify(selectedCouponMap))
    localStorage.setItem('selectedCommonCoupon', JSON.stringify(selectedCommonCoupon))
    return { ...state, selectedCouponMap, selectedCommonCoupon }
  }
}, initState)
